import React from "react";
import { Button, Tabs } from "antd";
import { observer } from "mobx-react";

import Customizer from "../Customizer.js";
import { Face, SavableFace } from "../../models/Book";
import { getSnapshot } from "mobx-state-tree";
import {
  imgsDaughterAoyama,
  imgsDadAoyama,
  imgsMomAoyama,
  imgsSonOkuta,
  imgsDadOkuta,
  imgsMomOkuta
} from "./FaceSelectionImage";

const TabPane = Tabs.TabPane;
class FaceSelection extends React.Component {
  constructor(props) {
    super();
    this.state = {
      creator: SavableFace.create({
        layer1: props.book.childToParent.creatorFace.layer1 !== ''
          ? props.book.childToParent.creatorFace.layer1
          : (props.artistName === "aoyama" ? '01_face' : '01_face'),
        layer2: props.book.childToParent.creatorFace.layer2 !== ''
          ? props.book.childToParent.creatorFace.layer2
          : (props.artistName === "aoyama" ? '00_mole' : '00_mole'),
        layer3: props.book.childToParent.creatorFace.layer3 !== ''
          ? props.book.childToParent.creatorFace.layer3
          : (props.artistName === "aoyama" ? '00_cheeks' : '00_hige'),
        layer4: props.book.childToParent.creatorFace.layer4 !== ''
          ? props.book.childToParent.creatorFace.layer4
          : (props.artistName === "aoyama" ? '00_glasses' : '00_glasses'),
        layer5: props.book.childToParent.creatorFace.layer5 !== ''
          ? props.book.childToParent.creatorFace.layer5
          : (props.artistName === "aoyama" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      dad: SavableFace.create({
        layer1: props.book.childToParent.dadFace.layer1 !== ''
          ? props.book.childToParent.dadFace.layer1
          : (props.artistName === "aoyama" ? '01_face' : '01_face'),
        layer2: props.book.childToParent.dadFace.layer2 !== ''
          ? props.book.childToParent.dadFace.layer2
          : (props.artistName === "aoyama" ? '00_mole' : '00_mole'),
        layer3: props.book.childToParent.dadFace.layer3 !== ''
          ? props.book.childToParent.dadFace.layer3
          : (props.artistName === "aoyama" ? '00_hige' : '00_hige'),
        layer4: props.book.childToParent.dadFace.layer4 !== ''
          ? props.book.childToParent.dadFace.layer4
          : (props.artistName === "aoyama" ? '00_glasses' : '00_glasses'),
        layer5: props.book.childToParent.dadFace.layer5 !== ''
          ? props.book.childToParent.dadFace.layer5
          : (props.artistName === "aoyama" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      mom: SavableFace.create({
        layer1: props.book.childToParent.momFace.layer1 !== ''
          ? props.book.childToParent.momFace.layer1
          : (props.artistName === "aoyama" ? '01_face' : '01_face'),
        layer2: props.book.childToParent.momFace.layer2 !== ''
          ? props.book.childToParent.momFace.layer2
          : (props.artistName === "aoyama" ? '00_mole' : '00_mole'),
        layer3: props.book.childToParent.momFace.layer3 !== ''
          ? props.book.childToParent.momFace.layer3
          : (props.artistName === "aoyama" ? '00_cheeks' : '00_cheeks'),
        layer4: props.book.childToParent.momFace.layer4 !== ''
          ? props.book.childToParent.momFace.layer4
          : (props.artistName === "aoyama" ? '00_glasses' : '00_glasses'),
        layer5: props.book.childToParent.momFace.layer5 !== ''
          ? props.book.childToParent.momFace.layer5
          : (props.artistName === "aoyama" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
    };
  }

  save = () => {
    this.props.book.childToParent.creatorFace.changeAll(getSnapshot(this.state.creator));
    this.props.book.childToParent.dadFace.changeAll(getSnapshot(this.state.dad));
    this.props.book.childToParent.momFace.changeAll(getSnapshot(this.state.mom));

    this.state.creator.save();
    this.state.dad.save();
    this.state.mom.save();

    this.props.order.saveFaces(); // facesSavedのフラグ更新
    this.props.order.nextStep();
  }

  render() {
    const { childToParent } = this.props.book;
    const receiver = childToParent.receiver;

    const imgsCreator = this.props.artistName === "aoyama"
      ? imgsDaughterAoyama
      : imgsSonOkuta;
    let imgsDad = this.props.artistName === "aoyama"
      ? imgsDadAoyama
      : imgsDadOkuta;
    let imgsMom = this.props.artistName === "aoyama"
      ? imgsMomAoyama
      : imgsMomOkuta;

    const creatorFace = this.state.creator;
    const dadFace = this.state.dad;
    const momFace = this.state.mom;

    return (
      <div className="hair-selection">
        {receiver !== 'mom' && // 母のみ以外
        <div>
          <div className="step pd-15">
            <div className="step-title">{"STEP 1：父の顔"}</div>
            <div className="step-txt">
              {"プレゼントするお父さんの顔をつくりましょう。"}
              <br />
              {"（左右の矢印をタップすると各パーツが切り替わります）"}
            </div>
          </div>
          <Customizer imgs={imgsDad} face={dadFace} />
        </div>
        }
        {receiver !== 'dad' && // 父のみ以外
        <div>
          <div className="step step-2 pd-15">
            <div className="step-title">{`STEP ${receiver === '' ? '2' : '1'}：母の顔`}</div>
            <div className="step-txt">
              {"プレゼントするお母様の顔をつくりましょう。"}
              <br />
              {"（左右の矢印をタップすると各パーツが切り替わります）"}
            </div>
          </div>
          <Customizer imgs={imgsMom} face={momFace} />
        </div>
        }
        <div className="step step-2 pd-15">
          <div className="step-title">{`STEP ${receiver === '' ? '3' : '2'}：あなたの顔`}</div>
          <div className="step-txt">
            {"最後に贈り主であるあなたの顔をつくりましょう。"}
            <br />
            {"（左右の矢印をタップすると各パーツが切り替わります）"}
          </div>
        </div>
        <Customizer imgs={imgsCreator} face={creatorFace} />
        <div style={{ padding: "0px 16px" }}>
          <div className="btn-wrap">
            <button onClick={this.save} className="btn product-btn">
              {"保存して次へ"}
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(FaceSelection);



// WEBPACK FOOTER //
// ./src/components/steps/FaceSelectionChildToParent.js